import type { Snapshot } from '@/entities/snapshot';
import type { RequestMeta, ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

/**
 * Returns a paginated list of Snapshots.
 *
 */
export const getSnapshots = (
  params?: RequestMeta,
): Promise<{ snapshots: Snapshot[]; meta: ResponseMeta }> =>
  request({
    url: '/snapshots/',
    method: 'GET',
    params,
  });
